import CreateNewBranch from '../views/shared/settings/branch/CreateNewBranch';
import useModal from './modalHook';
import { useQueryClient } from '@tanstack/react-query';
import { deleteBranch, getAllBranches, searchBranchByName } from '../api/requests';
import ActionConfirmation from '../components/elements/ActionConfirmation';
import { showToast } from '../utils/miscFunctions';
import EditBranch from '../views/shared/settings/branch/EditBranch';
import { IBranch } from '../views/shared/settings/branch';

const useBranch = () => {
  const { ModalComponent, updateModalStates, closeModal } = useModal();
  const BranchModal = ModalComponent;
  const queryClient = useQueryClient();
  const invalidateQueries = () => {
    queryClient.invalidateQueries({ queryKey: ['getBranchlist'] });
  }

  const getBranchlist = async (pageNumber: number, pageSize?: number, active?: boolean, companyId?: number, name?: string, offset?: number, paged?: boolean,) => {
    try {
      const response: any = await getAllBranches(pageNumber, pageSize, active, companyId, name)
      if (response) {
        return (response?.data?.content)

      }
    } catch (error) { }
  }

  const createNewBranchHandler = () => {
    updateModalStates({
      show: true,
      children: (
        <CreateNewBranch
          onClose={closeModal}
          onProceed={() => {
            queryClient.invalidateQueries({ queryKey: ['getBranchlist'] });
            closeModal();
          }}
        />
      ),
      size: 'md',
      showTitleSection: true,
      title: 'Add New Branch'
    });
  };

  const searchBranch = (name: string) => {
    searchBranchByName(name)
      .then((response: any) => {
        return (response?.data?.content)
      })
      .catch((error: Error) => {
        console.log("error", error)
      })
  }

  const updateBranchHandler = (branch: IBranch) => {
    updateModalStates({
      show: true,
      children: (
        <EditBranch
          onClose={closeModal}
          onProceed={() => {
            invalidateQueries();
            closeModal();
          }}
          address={branch.address}
          email={branch.email}
          name={branch.name}
          phone={branch.phone}
          id={branch.id}
          managerId={branch.manager ? branch.manager.id : null}
          active={branch.active}
        />
      ),
      size: 'md',
      showTitleSection: true,
      title: 'Edit Branch'
    });
  };

  const deleteBranchHandler = (branch: IBranch) => {
    updateModalStates({
      show: true,
      children: (
        <ActionConfirmation
          action="delete"
          type='danger'
          resourceType={''}
          resourceName={''}
          onClose={closeModal}
          onConfirm={() => {
            deleteBranch(branch.id)
              .then((response: any) => {

                closeModal();
                showToast.success(response.message);
                invalidateQueries();

              })
              .catch((error: any) => {
                console.log(error);
                closeModal();
                showToast.error(error.description);
              });
          }}
        />
      ),
      size: 'sm',
      showTitleSection: true,
      title: 'Delete Branch'
    });
  }

  return {
    createNewBranchHandler,
    BranchModal,
    getBranchlist,
    deleteBranchHandler,
    updateBranchHandler,
    searchBranch
  }


}

export default useBranch;